import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Schedule Of Rate';

const routes = [
    {
        matchRegex: '/ScheduleOfRate/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_V_SECTION,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'audit-trail-sor-lib', label: 'Adit Trail Sor Lib' },
            ],
        },
    },
]

export default routes;